"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
require("../SuperPager.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LoadMore = function LoadMore(props) {
  var handleClick = props.handleClick,
    styles = props.styles,
    hoverBg = props.hoverBg,
    hoverColor = props.hoverColor,
    disableButton = props.disableButton;
  var _ref = styles ? styles : {},
    width = _ref.width,
    bgColor = _ref.bgColor,
    color = _ref.color,
    fontSize = _ref.fontSize;
  var buttonRef = (0, _react.useRef)();
  var DEFAULT_BG_COLOR = "#2151FD";
  var DEFAULT_HOVER_COLOR = "#90a9f9";
  var styleOptions = {
    width: width,
    backgroundColor: bgColor,
    color: color,
    fontSize: fontSize,
    display: disableButton === false ? "none" : ""
  };
  (0, _react.useEffect)(function () {
    validation();
  }, []);
  var handleMouseEnter = function handleMouseEnter() {
    toggleColorChange("hover");
  };
  var handleMouseLeave = function handleMouseLeave() {
    toggleColorChange("default");
  };
  var toggleColorChange = function toggleColorChange(buttonState) {
    var current = buttonRef.current;
    var backgroundColor;
    var color;
    if (buttonState === "hover") {
      backgroundColor = hoverBg ? hoverBg : DEFAULT_HOVER_COLOR;
      color = hoverColor ? hoverColor : "#fff";
    } else if (buttonState === "default") {
      backgroundColor = bgColor ? bgColor : DEFAULT_BG_COLOR;
      color = color ? color : "#fff";
    }
    current.style.backgroundColor = backgroundColor;
    current.style.color = color;
  };
  var validation = function validation() {
    var errorMessage;
    var isError;
    if (!handleClick) {
      errorMessage = "handleClick prop is mandatory";
      isError = true;
    } else if (disableButton === "undefined") {
      errorMessage = "disabledButton prop is mandatory";
      isError = "true";
    }
    if (isError) {
      throw new Error(errorMessage);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "load-more-btn-container"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    ref: buttonRef,
    style: styleOptions,
    onClick: handleClick,
    className: "load-more-btn",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, "Load More"));
};
var _default = LoadMore;
exports["default"] = _default;